export default function (Vue) {
  // 深复制
  Vue.prototype.clone = function (obj) {
    if (typeof obj !== 'object') return obj
    if (JSON) {
      const str = JSON.stringify(obj)
      return JSON.parse(str)
    }
  }

  /**
   * 获取本机年月日
   * format: yyyy-MM-dd hh:mm:ss
   */
  Vue.prototype.formatTimeStamp = function (format) {
    var formatTime
    format = format || 'yyyy-MM-dd hh:mm:ss'
    var date = new Date()
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds() // 秒
    }
    if (/(y+)/.test(format)) {
      formatTime = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    } else {
      formatTime = format
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(formatTime)) {
        formatTime = formatTime.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k])
          .length)))
      }
    }
    return formatTime
  }

  /**
   * 时间戳转为普通日期格式
   * date: 时间戳
   */
  Vue.prototype.convertLocalTime = function (date) {
    if (date) {
      var date = new Date(date)
      var YY = date.getFullYear() + '-'
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
      return YY + MM + DD + ' ' + hh + mm
    }
    return ''
  }

  /**
   * 时间转时间戳
   * date: 字符串日期 yyyy-MM-dd hh:mm:ss || yyyy-MM-dd || yyyy-M-d
   */
  Vue.prototype.convertTimeStamp = function (date) {
    if (date && typeof date === 'string' && date.length >= 8) {
      return new Date(date.replace(/-/g, '/')).getTime()
    }
    return ''
  }

  // 秒换算 分:秒
  Vue.prototype.s_to_hs = function (s) {
    // 计算分钟：将秒数除以60，然后下舍入，得到分钟数
    var h
    h = Math.floor(s / 60)
    // 计算秒：取得秒%60的余数，得到秒数
    s = s % 60
    // 将变量转换为字符串
    h += ''
    s += ''
    // 如果只有一位数，前面增加一个0
    h = (h.length == 1) ? '0' + h : h
    s = (s.length == 1) ? '0' + s : s
    return h + ':' + s
  }

  // 时间戳转换时分秒
  Vue.prototype.fmtDHS = function (num) {
    if (isNaN(num)) return
    var h, m, s, mm, ss
    num = num < 0 ? 0 : num
    h = Math.floor(num / (60 * 60 * 1000))
    mm = num - (h * (60 * 60 * 1000))
    m = Math.floor(mm / (60 * 1000))
    ss = mm - (m * 60 * 1000)
    s = Math.floor(ss / (1000))
    h += ''
    m += ''
    s += ''
    h = (h.length == 1) ? '0' + h : h
    m = (m.length == 1) ? '0' + m : m
    s = (s.length == 1) ? '0' + s : s
    return h + ':' + m + ':' + s
  }

  // 生成随机字符数字, n=长度（默认5）
  Vue.prototype.generateMixed = function (n) {
    var res = ''
    n = Math.abs(Number(n) || 5)
    for (var i = 0; i < n; i++) {
      res += Math.floor(Math.random() * 10)
    }
    return res
  }

  // 随机生成字符串，n=长度（默认10）
  Vue.prototype.getRandomString = function (n) {
    const charStr = 'abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789'
    const max = charStr.length - 1
    let str = ''
    n = n || 10
    // 循环生成字符串
    for (var i = 0; i < n; i++) {
      const s = Math.round(Math.random() * max)
      str += charStr.substring(s, s + 1)
    }
    return str
  }

  // 范围随机数
  Vue.prototype.rangeNum = function (m, n) {
    return Math.ceil(Math.random() * (n - m + 1) + m - 1)
  }

  // 判断两个对象是否相等
  Vue.prototype.isObjectEqual = function (a, b) {
    var aProps = Object.getOwnPropertyNames(a)
    var bProps = Object.getOwnPropertyNames(b)
    var propName; var i = 0
    if (aProps.length !== bProps.length) return
    for (i; i < aProps.length; i++) {
      propName = aProps[i]
      if (a[propName] !== b[propName]) return
    }
    return true
  }

  // 指定日期添加天数
  Vue.prototype.dateAddDays = function (dateStr, dayCount) {
    if (!dateStr) return
    if (!dayCount) return dateStr
    if (dateStr.length == 8) {
      const y = dateStr.substr(0, 4)
      const m = dateStr.substr(4, 2)
      const d = dateStr.substr(6, 2)
      dateStr = `${y}-${m}-${d}`
    }
    var tempDate = new Date(dateStr.replace(/-/g, '/'))// 把日期字符串转换成日期格式
    var resultDate = new Date((tempDate / 1000 + (86400 * dayCount)) * 1000)// 增加n天后的日期
    var MM = (resultDate.getMonth() + 1 < 10 ? '0' + (resultDate.getMonth() + 1) : resultDate.getMonth() + 1)
    var DD = (resultDate.getDate() < 10 ? '0' + (resultDate.getDate()) : resultDate.getDate())
    return resultDate.getFullYear() + '-' + MM + '-' + DD
  }

  // 格式金额。例：1000 => 1,000.00
  Vue.prototype.formatMoney = function (s, n) {
    s = s || 0
    n = n > 0 && n <= 20 ? n : 2
    s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
    var l = s.split('.')[0].split('').reverse()
    var r = s.split('.')[1]
    var str = ''
    for (var i = 0; i < l.length; i++) {
      str += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? ',' : '')
    }
    return str.split('').reverse().join('') + '.' + r
  }

  // 生成范围数字
  Vue.prototype.rangeNum = function (m, n) {
    return Math.ceil(Math.random() * (n - m + 1) + m - 1)
  }
}
